import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import Detail from '../shared/Detail'

const EventDetails = ({ date, location, ...rest }) => {
  return (
    <div {...rest}>
      <Detail description="Datum" content={date} />
      <Detail description="Ort" content={location} />
    </div>
  )
}

export default EventDetails



// WEBPACK FOOTER //
// ./src/components/events/EventDetails.js